export function emit (vnode, eventName, data = null) {
    if (vnode.componentInstance) {
        vnode.componentInstance.$emit(eventName, { detail: data })
    } else {
        vnode.elm.dispatchEvent(new CustomEvent(eventName, { detail: data }))
    }
}
